<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_TYPE_PRODUCT_ID'
        )
      }"
    >
      <select
        v-model="$parent.project.UF_TYPE_PRODUCT_ID"
        v-on:change="showDesc()"
        :disabled="$parent.$parent.projectDisabled"
        class="sel-dropdown i-main-style i-wid-29"
      >
        <option
          v-for="item in $parent.directory.sp_type_productions"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="item.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_TYPE_PRODUCT_ID"
          )
        }}
      </div>
    </div>

    <div class="col-xs-12 mycol content-mb-14" v-if="isShowDesc">
      <br />
      <p class="content-s-2-label">
        <label>
          Сведения о конечной продукции, для производства которой необходима
          продукция проекта
        </label>
      </p>
      <div
        class="col-xs-12 mycol"
        v-bind:class="{
          'has-error': $parent.$parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_TYPE_PRODUCT_DESC'
          )
        }"
      >
        <textarea
          v-on:keyup="
            $parent.$parent.removeError(
              'PROJECTS',
              'LOGIC',
              'UF_TYPE_PRODUCT_DESC'
            )
          "
          class="i-main-style t-dop-style i-wid-50"
          style="height:56px;"
          v-model="$parent.project.UF_TYPE_PRODUCT_DESC"
          :disabled="$parent.$parent.projectDisabled"
          placeholder=""
        ></textarea>
        <div class="error-text">
          {{
            $parent.$parent.checkErrorText(
              "PROJECTS",
              "LOGIC",
              "UF_TYPE_PRODUCT_DESC"
            )
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FETCH_DIRECTORY } from "@/store/actions.type";

export default {
  name: "uf_type_product_list",
  data() {
    return {
      isShowDesc: false
    };
  },
  methods: {
    showDesc() {
      this.$parent.$parent.removeError(
        "PROJECTS",
        "LOGIC",
        "UF_TYPE_PRODUCT_ID"
      );
      this.isShowDesc = false;
      this.$parent.directory.sp_type_productions.filter(function(el) {
        if (
          el.ID == this.$parent.project.UF_TYPE_PRODUCT_ID &&
          el.IS_VIEW_DESC == 1
        ) {
          this.isShowDesc = true;
        }
      }, this);
    }
  },
  mounted() {
    this.$store.dispatch(FETCH_DIRECTORY, ["sp_type_productions"]).then(() => {
      this.$parent.directory.sp_type_productions.filter(function(el) {
        if (
          el.ID == this.$parent.project.UF_TYPE_PRODUCT_ID &&
          el.IS_VIEW_DESC == 1
        ) {
          this.isShowDesc = true;
        }
      }, this);
    }, this);
  }
};
</script>

<style scoped></style>
